export default __webpack_public_path__ + "static/media/logo-flat.4eaea26c.png";